export const TYPES = {
  // authen
  ACTION_LOGIN_SUCCESS: "ACTION_LOGIN_SUCCESS",
  ACTION_LOGIN_FAIL: "ACTION_LOGIN_FAIL",
  ACTION_CALL_API_FAIL: "ACTION_CALL_API_FAIL",

  ACTION_GET_USER_SUCCESS: "ACTION_GET_USER_SUCCESS",
  ACTION_GET_USER_FAIL: "ACTION_GET_USER_FAIL",

  ACTION_CHANGE_PASSWORD_SUCCESS: "ACTION_CHANGE_PASSWORD_SUCCESS",
  ACTION_CHANGE_PASSWORD_FAIL: "ACTION_CHANGE_PASSWORD_FAIL",

  ACTION_GET_EXERCISE_ACTION_CONFIG_SUCCESS: "ACTION_GET_EXERCISE_ACTION_CONFIG_SUCCESS",
  ACTION_GET_EXERCISE_ACTION_CONFIG_FAIL: "ACTION_GET_EXERCISE_ACTION_CONFIG_FAIL",

  ACTION_GET_MY_EXERCISES_SUCCESS: "ACTION_GET_MY_EXERCISES_SUCCESS",
  ACTION_GET_MY_EXERCISES_FAIL: "ACTION_GET_MY_EXERCISES_FAIL",

  ACTION_GET_MY_DIARIES_SUCCESS: "ACTION_GET_MY_DIARIES_SUCCESS",
  ACTION_GET_MY_DIARIES_FAIL: "ACTION_GET_MY_DIARIES_FAIL",

  ACTION_GET_BODY_RECORD_HOUR_SUCCESS: "ACTION_GET_BODY_RECORD_HOUR_SUCCESS",
  ACTION_GET_BODY_RECORD_HOUR_FAIL: "ACTION_GET_BODY_RECORD_HOUR_FAIL",

  ACTION_GET_BODY_RECORD_DAY_WEEK_SUCCESS: "ACTION_GET_BODY_RECORD_DAY_WEEK_SUCCESS",
  ACTION_GET_BODY_RECORD_DAY_WEEK_FAIL: "ACTION_GET_BODY_RECORD_DAY_WEEK_FAIL",

  ACTION_GET_BODY_RECORD_DAY_SUCCESS: "ACTION_GET_BODY_RECORD_DAY_SUCCESS",
  ACTION_GET_BODY_RECORD_DAY_FAIL: "ACTION_GET_BODY_RECORD_DAY_FAIL",

  ACTION_GET_BODY_RECORD_MONTH_SUCCESS: "ACTION_GET_BODY_RECORD_MONTH_SUCCESS",
  ACTION_GET_BODY_RECORD_MONTH_FAIL: "ACTION_GET_BODY_RECORD_MONTH_FAIL",

  ACTION_SET_FLAG_SUCCESS: "ACTION_SET_FLAG_SUCCESS",

  // socket
  ACTION_SEND_MESSAGE: "ACTION_SEND_MESSAGE",
  ACTION_ADD_MESSAGE: "ACTION_ADD_MESSAGE",
  ACTION_CLEAR_ALL_MESSAGES: "ACTION_CLEAR_ALL_MESSAGES",

  // listing
  ACTION_GET_LISTINGS_SUCCESS: "ACTION_GET_LISTINGS_SUCCESS",
  ACTION_GET_LISTINGS_FAIL: "ACTION_GET_LISTINGS_FAIL",

  ACTION_ADD_ALL_LISTING_TO_NEW_COLLECTION_SUCCESS: "ACTION_ADD_ALL_LISTING_TO_NEW_COLLECTION_SUCCESS",
  ACTION_ADD_ALL_LISTING_TO_NEW_COLLECTION_FAIL: "ACTION_ADD_ALL_LISTING_TO_NEW_COLLECTION_FAIL",

  ACTION_GET_LISTING_BY_IDS_SUCCESS: "ACTION_GET_LISTING_BY_IDS_SUCCESS",
  ACTION_GET_LISTING_BY_IDS_FAIL: "ACTION_GET_LISTING_BY_IDS_FAIL",

  ACTION_POST_LISTINGS_SUCCESS: "ACTION_POST_LISTINGS_SUCCESS",
  ACTION_POST_LISTINGS_FAIL: "ACTION_POST_LISTINGS_FAIL",

  ACTION_UPDATE_LISTINGS_HEYDATA_SUCCESS: "ACTION_UPDATE_LISTINGS_HEYDATA_SUCCESS",
  ACTION_UPDATE_LISTINGS_HEYDATA_FAIL: "ACTION_UPDATE_LISTINGS_HEYDATA_FAIL",

  ACTION_GET_LISTINGS_30_DAYS_SOLD_SUCCESS: "ACTION_GET_LISTINGS_30_DAYS_SOLD_SUCCESS",
  ACTION_GET_LISTINGS_30_DAYS_SOLD_FAIL: "ACTION_GET_LISTINGS_30_DAYS_SOLD_FAIL",

  // shop
  ACTION_GET_EIT_SHOPS_SUCCESS: "ACTION_GET_EIT_SHOPS_SUCCESS",
  ACTION_GET_EIT_SHOPS_FAIL: "ACTION_GET_EIT_SHOPS_FAIL",

  // shop sold chart
  ACTION_GET_EIT_SHOP_SOLD_STAT_SUCCESS: "ACTION_GET_EIT_SHOP_SOLD_STAT_SUCCESS",
  ACTION_GET_EIT_SHOP_SOLD_STAT_FAIL: "ACTION_GET_EIT_SHOP_SOLD_STAT_FAIL",

  ACTION_GET_EIT_SHOP_SOLD_STAT_GROUP_SUCCESS: "ACTION_GET_EIT_SHOP_SOLD_STAT_GROUP_SUCCESS",
  ACTION_GET_EIT_SHOP_SOLD_STAT_GROUP_FAIL: "ACTION_GET_EIT_SHOP_SOLD_STAT_GROUP_FAIL",

  ACTION_GET_EIT_SHOP_SOLD_SUCCESS: "ACTION_GET_EIT_SHOP_SOLD_SUCCESS",
  ACTION_GET_EIT_SHOP_SOLD_FAIL: "ACTION_GET_EIT_SHOP_SOLD_FAIL",

  ACTION_GET_LATEST_SHOP_SOLD_SUCCESS: "ACTION_GET_LATEST_SHOP_SOLD_SUCCESS",
  ACTION_GET_LATEST_SHOP_SOLD_FAIL: "ACTION_GET_LATEST_SHOP_SOLD_FAIL",

  // task
  ACTION_GET_ALL_TASKS_SUCCESS: "ACTION_GET_ALL_TASKS_SUCCESS",
  ACTION_GET_ALL_TASKS_FAIL: "ACTION_GET_ALL_TASKS_FAIL",

  ACTION_GET_ALL_BOT_TASKS_SUCCESS: "ACTION_GET_ALL_BOT_TASKS_SUCCESS",
  ACTION_GET_ALL_BOT_TASKS_FAIL: "ACTION_GET_ALL_BOT_TASKS_FAIL",

  ACTION_UPDATE_TASK_SUCCESS: "ACTION_UPDATE_TASK_SUCCESS",
  ACTION_UPDATE_TASK_FAIL: "ACTION_UPDATE_TASK_FAIL",

  ACTION_DELETE_TASK_SUCCESS: "ACTION_DELETE_TASK_SUCCESS",
  ACTION_DELETE_TASK_FAIL: "ACTION_DELETE_TASK_FAIL",

  ACTION_GET_LOGS_SUCCESS: "ACTION_GET_LOGS_SUCCESS",
  ACTION_GET_LOGS_FAIL: "ACTION_GET_LOGS_FAIL",

  // collection
  ACTION_GET_ALL_COLLECTIONS_SUCCESS: "ACTION_GET_ALL_COLLECTIONS_SUCCESS",
  ACTION_GET_ALL_COLLECTIONS_FAIL: "ACTION_GET_ALL_COLLECTIONS_FAIL",

  ACTION_ADD_NEW_COLLECTION_SUCCESS: "ACTION_ADD_NEW_COLLECTION_SUCCESS",
  ACTION_ADD_NEW_COLLECTION_FAIL: "ACTION_ADD_NEW_COLLECTION_FAIL",

  ACTION_TOGGLE_LISTING_IN_COLLECTION_SUCCESS: "ACTION_TOGGLE_LISTING_IN_COLLECTION_SUCCESS",
  ACTION_TOGGLE_LISTING_IN_COLLECTION_FAIL: "ACTION_TOGGLE_LISTING_IN_COLLECTION_FAIL",

  ACTION_REMOVE_LISTING_FROM_COLLECTION_SUCCESS: "ACTION_REMOVE_LISTING_FROM_COLLECTION_SUCCESS",
  ACTION_REMOVE_LISTING_FROM_COLLECTION_FAIL: "ACTION_REMOVE_LISTING_FROM_COLLECTION_FAIL",

  ACTION_UPDATE_COLLECTION_SUCCESS: "ACTION_UPDATE_COLLECTION_SUCCESS",
  ACTION_UPDATE_COLLECTION_FAIL: "ACTION_UPDATE_COLLECTION_FAIL",

  // bot
  ACTION_GET_ALL_BOTS_SUCCESS: "ACTION_GET_ALL_BOTS_SUCCESS",
  ACTION_GET_ALL_BOTS_FAIL: "ACTION_GET_ALL_BOTS_FAIL",

  ACTION_GET_LOCAL_DATA_SUCCESS: "ACTION_GET_LOCAL_DATA_SUCCESS",
  ACTION_GET_LOCAL_DATA_FAIL: "ACTION_GET_LOCAL_DATA_FAIL",

  // etsy shop
  ACTION_GET_ETSY_SHOPS_SUCCESS: "ACTION_GET_ETSY_SHOPS_SUCCESS",
  ACTION_GET_ETSY_SHOPS_FAIL: "ACTION_GET_ETSY_SHOPS_FAIL",

  // agent
  ACTION_GET_AGENTS_SUCCESS: "ACTION_GET_AGENTS_SUCCESS",
  ACTION_GET_AGENTS_FAIL: "ACTION_GET_AGENTS_FAIL",

  ACTION_UPDATE_AGENT_SUCCESS: "ACTION_UPDATE_AGENT_SUCCESS",
  ACTION_UPDATE_AGENT_FAIL: "ACTION_UPDATE_AGENT_FAIL",

  ACTION_GET_ORDERS_SUCCESS: 'ACTION_GET_ORDERS_SUCCESS',
  ACTION_GET_ORDERS_FAIL: 'ACTION_GET_ORDERS_FAIL',
  ACTION_UPDATE_ORDERS_SUCCESS: 'ACTION_UPDATE_ORDERS_SUCCESS',
  ACTION_UPDATE_ORDERS_FAIL: 'ACTION_UPDATE_ORDERS_FAIL',

  // SES Product
  ACTION_GET_SES_PRODUCTS_SUCCESS: "ACTION_GET_SES_PRODUCTS_SUCCESS",
  ACTION_GET_SES_PRODUCTS_FAIL: "ACTION_GET_SES_PRODUCTS_FAIL",
  ACTION_GET_SES_PRODUCTS_VERSION_SUCCESS: "ACTION_GET_SES_PRODUCTS_VERSION_SUCCESS",
  ACTION_GET_SES_PRODUCTS_VERSION_FAIL: "ACTION_GET_SES_PRODUCTS_VERSION_FAIL",
  ACTION_SET_SES_PRODUCTS_SUCCESS: "ACTION_SET_SES_PRODUCTS_SUCCESS",
  ACTION_SET_SES_PRODUCTS_FAIL: "ACTION_SET_SES_PRODUCTS_FAIL",
  ACTION_ADD_SES_PRODUCTS_SUCCESS: "ACTION_ADD_SES_PRODUCTS_SUCCESS",
  ACTION_ADD_SES_PRODUCTS_FAIL: "ACTION_ADD_SES_PRODUCTS_FAIL",
  ACTION_GET_SES_PRODUCT_BY_ID_SUCCESS: "ACTION_GET_SES_PRODUCT_BY_ID_SUCCESS",
  ACTION_GET_SES_PRODUCT_BY_ID_FAIL: "ACTION_GET_SES_PRODUCT_BY_ID_FAIL",
  ACTION_CREATE_SES_PRODUCT_SUCCESS: "ACTION_CREATE_SES_PRODUCT_SUCCESS",
  ACTION_CREATE_SES_PRODUCT_FAIL: "ACTION_CREATE_SES_PRODUCT_FAIL",
  ACTION_UPDATE_SES_PRODUCT_SUCCESS: "ACTION_UPDATE_SES_PRODUCT_SUCCESS",
  ACTION_UPDATE_SES_PRODUCT_FAIL: "ACTION_UPDATE_SES_PRODUCT_FAIL",
  ACTION_DELETE_SES_PRODUCT_SUCCESS: "ACTION_DELETE_SES_PRODUCT_SUCCESS",
  ACTION_DELETE_SES_PRODUCT_FAIL: "ACTION_DELETE_SES_PRODUCT_FAIL",

  // SES Product Quantity Change
  ACTION_GET_SES_PRODUCT_QTY_CHANGES_SUCCESS: "ACTION_GET_SES_PRODUCT_QTY_CHANGES_SUCCESS",
  ACTION_GET_SES_PRODUCT_QTY_CHANGES_FAIL: "ACTION_GET_SES_PRODUCT_QTY_CHANGES_FAIL",
  ACTION_SET_SES_PRODUCT_QTY_CHANGES_SUCCESS: "ACTION_SET_SES_PRODUCT_QTY_CHANGES_SUCCESS",
  ACTION_SET_SES_PRODUCT_QTY_CHANGES_FAIL: "ACTION_SET_SES_PRODUCT_QTY_CHANGES_FAIL",
  ACTION_ADD_SES_PRODUCT_QTY_CHANGES_SUCCESS: "ACTION_ADD_SES_PRODUCT_QTY_CHANGES_SUCCESS",
  ACTION_ADD_SES_PRODUCT_QTY_CHANGES_FAIL: "ACTION_ADD_SES_PRODUCT_QTY_CHANGES_FAIL",
  ACTION_GET_SES_PRODUCT_QTY_CHANGE_BY_ID_SUCCESS: "ACTION_GET_SES_PRODUCT_QTY_CHANGE_BY_ID_SUCCESS",
  ACTION_GET_SES_PRODUCT_QTY_CHANGE_BY_ID_FAIL: "ACTION_GET_SES_PRODUCT_QTY_CHANGE_BY_ID_FAIL",
  ACTION_CREATE_SES_PRODUCT_QTY_CHANGE_SUCCESS: "ACTION_CREATE_SES_PRODUCT_QTY_CHANGE_SUCCESS",
  ACTION_CREATE_SES_PRODUCT_QTY_CHANGE_FAIL: "ACTION_CREATE_SES_PRODUCT_QTY_CHANGE_FAIL",
  ACTION_UPDATE_SES_PRODUCT_QTY_CHANGE_SUCCESS: "ACTION_UPDATE_SES_PRODUCT_QTY_CHANGE_SUCCESS",
  ACTION_UPDATE_SES_PRODUCT_QTY_CHANGE_FAIL: "ACTION_UPDATE_SES_PRODUCT_QTY_CHANGE_FAIL",
  ACTION_DELETE_SES_PRODUCT_QTY_CHANGE_SUCCESS: "ACTION_DELETE_SES_PRODUCT_QTY_CHANGE_SUCCESS",
  ACTION_DELETE_SES_PRODUCT_QTY_CHANGE_FAIL: "ACTION_DELETE_SES_PRODUCT_QTY_CHANGE_FAIL",

  // SIV Product Inventory Transaction
  ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTIONS_SUCCESS: "ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTIONS_SUCCESS",
  ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTIONS_FAIL: "ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTIONS_FAIL",
  ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTION_BY_ID_SUCCESS: "ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTION_BY_ID_SUCCESS",
  ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTION_BY_ID_FAIL: "ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTION_BY_ID_FAIL",
  ACTION_SET_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS: "ACTION_SET_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS",
  ACTION_SET_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL: "ACTION_SET_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL",
  ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS: "ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS",
  ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL: "ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL",
  ACTION_DELETE_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS: "ACTION_DELETE_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS",
  ACTION_DELETE_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL: "ACTION_DELETE_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL",
  ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_DATE_SUCCESS: "ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_DATE_SUCCESS",
  ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_DATE_FAIL: "ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_DATE_FAIL",

  // company
  ACTION_GET_COMPANIES_SUCCESS: "ACTION_GET_COMPANIES_SUCCESS",
  ACTION_GET_COMPANIES_FAIL: "ACTION_GET_COMPANIES_FAIL",

  ACTION_GET_COMPANY_BY_ID_SUCCESS: "ACTION_GET_COMPANY_BY_ID_SUCCESS",
  ACTION_GET_COMPANY_BY_ID_FAIL: "ACTION_GET_COMPANY_BY_ID_FAIL",

  ACTION_GET_COMPANY_BY_COMPANY_ID_SUCCESS: "ACTION_GET_COMPANY_BY_COMPANY_ID_SUCCESS",
  ACTION_GET_COMPANY_BY_COMPANY_ID_FAIL: "ACTION_GET_COMPANY_BY_COMPANY_ID_FAIL",

  ACTION_CREATE_COMPANY_SUCCESS: "ACTION_CREATE_COMPANY_SUCCESS",
  ACTION_CREATE_COMPANY_FAIL: "ACTION_CREATE_COMPANY_FAIL",

  ACTION_UPDATE_COMPANY_SUCCESS: "ACTION_UPDATE_COMPANY_SUCCESS",
  ACTION_UPDATE_COMPANY_FAIL: "ACTION_UPDATE_COMPANY_FAIL",

  ACTION_DELETE_COMPANY_SUCCESS: "ACTION_DELETE_COMPANY_SUCCESS",
  ACTION_DELETE_COMPANY_FAIL: "ACTION_DELETE_COMPANY_FAIL",

  // Permission
  ACTION_GET_PERMISSIONS_LOADING: "ACTION_GET_PERMISSIONS_LOADING",
  ACTION_GET_PERMISSIONS_SUCCESS: "ACTION_GET_PERMISSIONS_SUCCESS",
  ACTION_GET_PERMISSIONS_FAIL: "ACTION_GET_PERMISSIONS_FAIL",

  // User Group
  ACTION_SET_USER_GROUPS_LOADING: "ACTION_SET_USER_GROUPS_LOADING",
  ACTION_SET_USER_GROUPS_SUCCESS: "ACTION_SET_USER_GROUPS_SUCCESS",
  ACTION_SET_USER_GROUPS_FAIL: "ACTION_SET_USER_GROUPS_FAIL",

  ACTION_CREATE_USER_GROUP_LOADING: "ACTION_CREATE_USER_GROUP_LOADING",
  ACTION_CREATE_USER_GROUP_SUCCESS: "ACTION_CREATE_USER_GROUP_SUCCESS",
  ACTION_CREATE_USER_GROUP_FAIL: "ACTION_CREATE_USER_GROUP_FAIL",

  ACTION_GET_USER_GROUPS_LOADING: "ACTION_GET_USER_GROUPS_LOADING",
  ACTION_GET_USER_GROUPS_SUCCESS: "ACTION_GET_USER_GROUPS_SUCCESS",
  ACTION_GET_USER_GROUPS_FAIL: "ACTION_GET_USER_GROUPS_FAIL",

  ACTION_GET_USERS_LOADING: "ACTION_GET_USERS_LOADING",
  ACTION_GET_USERS_SUCCESS: "ACTION_GET_USERS_SUCCESS",
  ACTION_GET_USERS_FAIL: "ACTION_GET_USERS_FAIL",

  ACTION_SET_USERS_LOADING: "ACTION_SET_USERS_LOADING",
  ACTION_SET_USERS_SUCCESS: "ACTION_SET_USERS_SUCCESS",
  ACTION_SET_USERS_FAIL: "ACTION_SET_USERS_FAIL",

  // K3Doc
  ACTION_GET_K3DOCS_SUCCESS: "ACTION_GET_K3DOCS_SUCCESS",
  ACTION_GET_K3DOCS_FAIL: "ACTION_GET_K3DOCS_FAIL",
  ACTION_GET_K3DOC_SUCCESS: "ACTION_GET_K3DOC_SUCCESS",
  ACTION_GET_K3DOC_FAIL: "ACTION_GET_K3DOC_FAIL",
  ACTION_SET_K3DOCS_SUCCESS: "ACTION_SET_K3DOCS_SUCCESS",
  ACTION_SET_K3DOCS_FAIL: "ACTION_SET_K3DOCS_FAIL",
  ACTION_GET_SALE_TEAM_STATUS_SUCCESS: 'ACTION_GET_SALE_TEAM_STATUS_SUCCESS',
  ACTION_GET_SALE_TEAM_STATUS_FAIL: 'ACTION_GET_SALE_TEAM_STATUS_FAIL',
  ACTION_GET_FULFILL_TEAM_STAT_SUCCESS: 'ACTION_GET_FULFILL_TEAM_STAT_SUCCESS',
  ACTION_GET_FULFILL_TEAM_STAT_FAIL: 'ACTION_GET_FULFILL_TEAM_STAT_FAIL',

  // TKT1 C3D Info
  ACTION_GET_TKT1_C3D_INFOS_SUCCESS: "ACTION_GET_TKT1_C3D_INFOS_SUCCESS",
  ACTION_GET_TKT1_C3D_INFOS_FAIL: "ACTION_GET_TKT1_C3D_INFOS_FAIL",
  ACTION_GET_TKT1_C3D_INFO_BY_ID_SUCCESS: "ACTION_GET_TKT1_C3D_INFO_BY_ID_SUCCESS",
  ACTION_GET_TKT1_C3D_INFO_BY_ID_FAIL: "ACTION_GET_TKT1_C3D_INFO_BY_ID_FAIL",
  ACTION_CREATE_TKT1_C3D_INFO_SUCCESS: "ACTION_CREATE_TKT1_C3D_INFO_SUCCESS",
  ACTION_CREATE_TKT1_C3D_INFO_FAIL: "ACTION_CREATE_TKT1_C3D_INFO_FAIL",
  ACTION_UPDATE_TKT1_C3D_INFO_SUCCESS: "ACTION_UPDATE_TKT1_C3D_INFO_SUCCESS",
  ACTION_UPDATE_TKT1_C3D_INFO_FAIL: "ACTION_UPDATE_TKT1_C3D_INFO_FAIL",
  ACTION_DELETE_TKT1_C3D_INFO_SUCCESS: "ACTION_DELETE_TKT1_C3D_INFO_SUCCESS",
  ACTION_DELETE_TKT1_C3D_INFO_FAIL: "ACTION_DELETE_TKT1_C3D_INFO_FAIL",

  // TKT1 Trusted Person Info Actions
  ACTION_GET_TKT1_TRUSTED_PERSON_INFOS_SUCCESS: "ACTION_GET_TKT1_TRUSTED_PERSON_INFOS_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_PERSON_INFOS_FAIL: "ACTION_GET_TKT1_TRUSTED_PERSON_INFOS_FAIL",
  ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_ID_SUCCESS: "ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_ID_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_ID_FAIL: "ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_ID_FAIL",
  ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_MID_SUCCESS: "ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_MID_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_MID_FAIL: "ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_MID_FAIL",
  ACTION_CREATE_TKT1_TRUSTED_PERSON_INFO_SUCCESS: "ACTION_CREATE_TKT1_TRUSTED_PERSON_INFO_SUCCESS",
  ACTION_CREATE_TKT1_TRUSTED_PERSON_INFO_FAIL: "ACTION_CREATE_TKT1_TRUSTED_PERSON_INFO_FAIL",
  ACTION_UPDATE_TKT1_TRUSTED_PERSON_INFO_SUCCESS: "ACTION_UPDATE_TKT1_TRUSTED_PERSON_INFO_SUCCESS",
  ACTION_UPDATE_TKT1_TRUSTED_PERSON_INFO_FAIL: "ACTION_UPDATE_TKT1_TRUSTED_PERSON_INFO_FAIL",
  ACTION_DELETE_TKT1_TRUSTED_PERSON_INFO_SUCCESS: "ACTION_DELETE_TKT1_TRUSTED_PERSON_INFO_SUCCESS",
  ACTION_DELETE_TKT1_TRUSTED_PERSON_INFO_FAIL: "ACTION_DELETE_TKT1_TRUSTED_PERSON_INFO_FAIL",

  // TKT1 Network Modem Actions
  ACTION_GET_TKT1_NETWORK_MODEMS_SUCCESS: "ACTION_GET_TKT1_NETWORK_MODEMS_SUCCESS",
  ACTION_GET_TKT1_NETWORK_MODEMS_FAIL: "ACTION_GET_TKT1_NETWORK_MODEMS_FAIL",
  ACTION_GET_TKT1_NETWORK_MODEM_BY_ID_SUCCESS: "ACTION_GET_TKT1_NETWORK_MODEM_BY_ID_SUCCESS",
  ACTION_GET_TKT1_NETWORK_MODEM_BY_ID_FAIL: "ACTION_GET_TKT1_NETWORK_MODEM_BY_ID_FAIL",
  ACTION_CREATE_TKT1_NETWORK_MODEM_SUCCESS: "ACTION_CREATE_TKT1_NETWORK_MODEM_SUCCESS",
  ACTION_CREATE_TKT1_NETWORK_MODEM_FAIL: "ACTION_CREATE_TKT1_NETWORK_MODEM_FAIL",
  ACTION_UPDATE_TKT1_NETWORK_MODEM_SUCCESS: "ACTION_UPDATE_TKT1_NETWORK_MODEM_SUCCESS",
  ACTION_UPDATE_TKT1_NETWORK_MODEM_FAIL: "ACTION_UPDATE_TKT1_NETWORK_MODEM_FAIL",
  ACTION_DELETE_TKT1_NETWORK_MODEM_SUCCESS: "ACTION_DELETE_TKT1_NETWORK_MODEM_SUCCESS",
  ACTION_DELETE_TKT1_NETWORK_MODEM_FAIL: "ACTION_DELETE_TKT1_NETWORK_MODEM_FAIL",

  // TKT1 PC Info
  ACTION_GET_TKT1_PC_INFOS_SUCCESS: "ACTION_GET_TKT1_PC_INFOS_SUCCESS",
  ACTION_GET_TKT1_PC_INFOS_FAIL: "ACTION_GET_TKT1_PC_INFOS_FAIL",
  ACTION_GET_TKT1_PC_INFO_BY_ID_SUCCESS: "ACTION_GET_TKT1_PC_INFO_BY_ID_SUCCESS",
  ACTION_GET_TKT1_PC_INFO_BY_ID_FAIL: "ACTION_GET_TKT1_PC_INFO_BY_ID_FAIL",
  ACTION_GET_TKT1_PC_INFO_BY_SN_SUCCESS: "ACTION_GET_TKT1_PC_INFO_BY_SN_SUCCESS",
  ACTION_GET_TKT1_PC_INFO_BY_SN_FAIL: "ACTION_GET_TKT1_PC_INFO_BY_SN_FAIL",
  ACTION_CREATE_TKT1_PC_INFO_SUCCESS: "ACTION_CREATE_TKT1_PC_INFO_SUCCESS",
  ACTION_CREATE_TKT1_PC_INFO_FAIL: "ACTION_CREATE_TKT1_PC_INFO_FAIL",
  ACTION_UPDATE_TKT1_PC_INFO_SUCCESS: "ACTION_UPDATE_TKT1_PC_INFO_SUCCESS",
  ACTION_UPDATE_TKT1_PC_INFO_FAIL: "ACTION_UPDATE_TKT1_PC_INFO_FAIL",
  ACTION_UPDATE_TKT1_PC_INFO_BY_SN_SUCCESS: "ACTION_UPDATE_TKT1_PC_INFO_BY_SN_SUCCESS",
  ACTION_UPDATE_TKT1_PC_INFO_BY_SN_FAIL: "ACTION_UPDATE_TKT1_PC_INFO_BY_SN_FAIL",
  ACTION_DELETE_TKT1_PC_INFO_SUCCESS: "ACTION_DELETE_TKT1_PC_INFO_SUCCESS",
  ACTION_DELETE_TKT1_PC_INFO_FAIL: "ACTION_DELETE_TKT1_PC_INFO_FAIL",
  
  // TKT1 SIM
  ACTION_GET_TKT1_SIMS_SUCCESS: "ACTION_GET_TKT1_SIMS_SUCCESS",
  ACTION_GET_TKT1_SIMS_FAIL: "ACTION_GET_TKT1_SIMS_FAIL",
  ACTION_GET_TKT1_SIM_BY_ID_SUCCESS: "ACTION_GET_TKT1_SIM_BY_ID_SUCCESS",
  ACTION_GET_TKT1_SIM_BY_ID_FAIL: "ACTION_GET_TKT1_SIM_BY_ID_FAIL",
  ACTION_GET_TKT1_SIM_BY_NUMBER_SUCCESS: "ACTION_GET_TKT1_SIM_BY_NUMBER_SUCCESS",
  ACTION_GET_TKT1_SIM_BY_NUMBER_FAIL: "ACTION_GET_TKT1_SIM_BY_NUMBER_FAIL",
  ACTION_CREATE_TKT1_SIM_SUCCESS: "ACTION_CREATE_TKT1_SIM_SUCCESS",
  ACTION_CREATE_TKT1_SIM_FAIL: "ACTION_CREATE_TKT1_SIM_FAIL",
  ACTION_UPDATE_TKT1_SIM_SUCCESS: "ACTION_UPDATE_TKT1_SIM_SUCCESS",
  ACTION_UPDATE_TKT1_SIM_FAIL: "ACTION_UPDATE_TKT1_SIM_FAIL",
  ACTION_UPDATE_TKT1_SIM_BY_NUMBER_SUCCESS: "ACTION_UPDATE_TKT1_SIM_BY_NUMBER_SUCCESS",
  ACTION_UPDATE_TKT1_SIM_BY_NUMBER_FAIL: "ACTION_UPDATE_TKT1_SIM_BY_NUMBER_FAIL",
  ACTION_DELETE_TKT1_SIM_SUCCESS: "ACTION_DELETE_TKT1_SIM_SUCCESS",
  ACTION_DELETE_TKT1_SIM_FAIL: "ACTION_DELETE_TKT1_SIM_FAIL",

  // TKT1 Email
  ACTION_GET_TKT1_EMAILS_SUCCESS: "ACTION_GET_TKT1_EMAILS_SUCCESS",
  ACTION_GET_TKT1_EMAILS_FAIL: "ACTION_GET_TKT1_EMAILS_FAIL",
  ACTION_GET_TKT1_EMAIL_BY_ID_SUCCESS: "ACTION_GET_TKT1_EMAIL_BY_ID_SUCCESS",
  ACTION_GET_TKT1_EMAIL_BY_ID_FAIL: "ACTION_GET_TKT1_EMAIL_BY_ID_FAIL",
  ACTION_GET_TKT1_EMAIL_BY_MID_SUCCESS: "ACTION_GET_TKT1_EMAIL_BY_MID_SUCCESS",
  ACTION_GET_TKT1_EMAIL_BY_MID_FAIL: "ACTION_GET_TKT1_EMAIL_BY_MID_FAIL",
  ACTION_CREATE_TKT1_EMAIL_SUCCESS: "ACTION_CREATE_TKT1_EMAIL_SUCCESS",
  ACTION_CREATE_TKT1_EMAIL_FAIL: "ACTION_CREATE_TKT1_EMAIL_FAIL",
  ACTION_UPDATE_TKT1_EMAIL_SUCCESS: "ACTION_UPDATE_TKT1_EMAIL_SUCCESS",
  ACTION_UPDATE_TKT1_EMAIL_FAIL: "ACTION_UPDATE_TKT1_EMAIL_FAIL",
  ACTION_UPDATE_TKT1_EMAIL_BY_MID_SUCCESS: "ACTION_UPDATE_TKT1_EMAIL_BY_MID_SUCCESS",
  ACTION_UPDATE_TKT1_EMAIL_BY_MID_FAIL: "ACTION_UPDATE_TKT1_EMAIL_BY_MID_FAIL",
  ACTION_DELETE_TKT1_EMAIL_SUCCESS: "ACTION_DELETE_TKT1_EMAIL_SUCCESS",
  ACTION_DELETE_TKT1_EMAIL_FAIL: "ACTION_DELETE_TKT1_EMAIL_FAIL",
  
  // TKT1 Device Pack
  ACTION_GET_TKT1_DEVICE_PACKS_SUCCESS: "ACTION_GET_TKT1_DEVICE_PACKS_SUCCESS",
  ACTION_GET_TKT1_DEVICE_PACKS_FAIL: "ACTION_GET_TKT1_DEVICE_PACKS_FAIL",
  ACTION_GET_TKT1_DEVICE_PACK_BY_ID_SUCCESS: "ACTION_GET_TKT1_DEVICE_PACK_BY_ID_SUCCESS",
  ACTION_GET_TKT1_DEVICE_PACK_BY_ID_FAIL: "ACTION_GET_TKT1_DEVICE_PACK_BY_ID_FAIL",
  ACTION_GET_TKT1_DEVICE_PACK_BY_SN_SUCCESS: "ACTION_GET_TKT1_DEVICE_PACK_BY_SN_SUCCESS",
  ACTION_GET_TKT1_DEVICE_PACK_BY_SN_FAIL: "ACTION_GET_TKT1_DEVICE_PACK_BY_SN_FAIL",
  ACTION_GET_TKT1_DEVICE_PACK_BY_NETWORK_SN_SUCCESS: "ACTION_GET_TKT1_DEVICE_PACK_BY_NETWORK_SN_SUCCESS",
  ACTION_GET_TKT1_DEVICE_PACK_BY_NETWORK_SN_FAIL: "ACTION_GET_TKT1_DEVICE_PACK_BY_NETWORK_SN_FAIL",
  ACTION_GET_TKT1_DEVICE_PACK_BY_PC_SN_SUCCESS: "ACTION_GET_TKT1_DEVICE_PACK_BY_PC_SN_SUCCESS",
  ACTION_GET_TKT1_DEVICE_PACK_BY_PC_SN_FAIL: "ACTION_GET_TKT1_DEVICE_PACK_BY_PC_SN_FAIL",
  ACTION_CREATE_TKT1_DEVICE_PACK_SUCCESS: "ACTION_CREATE_TKT1_DEVICE_PACK_SUCCESS",
  ACTION_CREATE_TKT1_DEVICE_PACK_FAIL: "ACTION_CREATE_TKT1_DEVICE_PACK_FAIL",
  ACTION_UPDATE_TKT1_DEVICE_PACK_SUCCESS: "ACTION_UPDATE_TKT1_DEVICE_PACK_SUCCESS",
  ACTION_UPDATE_TKT1_DEVICE_PACK_FAIL: "ACTION_UPDATE_TKT1_DEVICE_PACK_FAIL",
  ACTION_UPDATE_TKT1_DEVICE_PACK_BY_SN_SUCCESS: "ACTION_UPDATE_TKT1_DEVICE_PACK_BY_SN_SUCCESS",
  ACTION_UPDATE_TKT1_DEVICE_PACK_BY_SN_FAIL: "ACTION_UPDATE_TKT1_DEVICE_PACK_BY_SN_FAIL",
  ACTION_DELETE_TKT1_DEVICE_PACK_SUCCESS: "ACTION_DELETE_TKT1_DEVICE_PACK_SUCCESS",
  ACTION_DELETE_TKT1_DEVICE_PACK_FAIL: "ACTION_DELETE_TKT1_DEVICE_PACK_FAIL",

  // TKT1 Bank Brand Actions
  ACTION_GET_TKT1_BANK_BRANDS_SUCCESS: "ACTION_GET_TKT1_BANK_BRANDS_SUCCESS",
  ACTION_GET_TKT1_BANK_BRANDS_FAIL: "ACTION_GET_TKT1_BANK_BRANDS_FAIL",
  ACTION_GET_TKT1_BANK_BRAND_BY_ID_SUCCESS: "ACTION_GET_TKT1_BANK_BRAND_BY_ID_SUCCESS",
  ACTION_GET_TKT1_BANK_BRAND_BY_ID_FAIL: "ACTION_GET_TKT1_BANK_BRAND_BY_ID_FAIL",
  ACTION_GET_TKT1_BANK_BRAND_BY_CODE_SUCCESS: "ACTION_GET_TKT1_BANK_BRAND_BY_CODE_SUCCESS",
  ACTION_GET_TKT1_BANK_BRAND_BY_CODE_FAIL: "ACTION_GET_TKT1_BANK_BRAND_BY_CODE_FAIL",
  ACTION_SEARCH_TKT1_BANK_BRANDS_SUCCESS: "ACTION_SEARCH_TKT1_BANK_BRANDS_SUCCESS",
  ACTION_SEARCH_TKT1_BANK_BRANDS_FAIL: "ACTION_SEARCH_TKT1_BANK_BRANDS_FAIL",
  ACTION_CREATE_TKT1_BANK_BRAND_SUCCESS: "ACTION_CREATE_TKT1_BANK_BRAND_SUCCESS",
  ACTION_CREATE_TKT1_BANK_BRAND_FAIL: "ACTION_CREATE_TKT1_BANK_BRAND_FAIL",
  ACTION_UPDATE_TKT1_BANK_BRAND_SUCCESS: "ACTION_UPDATE_TKT1_BANK_BRAND_SUCCESS",
  ACTION_UPDATE_TKT1_BANK_BRAND_FAIL: "ACTION_UPDATE_TKT1_BANK_BRAND_FAIL",
  ACTION_DELETE_TKT1_BANK_BRAND_SUCCESS: "ACTION_DELETE_TKT1_BANK_BRAND_SUCCESS",
  ACTION_DELETE_TKT1_BANK_BRAND_FAIL: "ACTION_DELETE_TKT1_BANK_BRAND_FAIL",
  ACTION_GET_TKT1_BANK_BRAND_LOGOS_SUCCESS: "ACTION_GET_TKT1_BANK_BRAND_LOGOS_SUCCESS",
  ACTION_GET_TKT1_BANK_BRAND_LOGOS_FAIL: "ACTION_GET_TKT1_BANK_BRAND_LOGOS_FAIL",

  // TKT1 Trusted Bank Account Actions
  ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNTS_SUCCESS: "ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNTS_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNTS_FAIL: "ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNTS_FAIL",
  ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_ID_SUCCESS: "ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_ID_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_ID_FAIL: "ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_ID_FAIL",
  ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_MID_SUCCESS: "ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_MID_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_MID_FAIL: "ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_MID_FAIL",
  ACTION_SEARCH_TKT1_TRUSTED_BANK_ACCOUNTS_SUCCESS: "ACTION_SEARCH_TKT1_TRUSTED_BANK_ACCOUNTS_SUCCESS",
  ACTION_SEARCH_TKT1_TRUSTED_BANK_ACCOUNTS_FAIL: "ACTION_SEARCH_TKT1_TRUSTED_BANK_ACCOUNTS_FAIL",
  ACTION_CREATE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS: "ACTION_CREATE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS",
  ACTION_CREATE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL: "ACTION_CREATE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL",
  ACTION_UPDATE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS: "ACTION_UPDATE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS",
  ACTION_UPDATE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL: "ACTION_UPDATE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL",
  ACTION_DELETE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS: "ACTION_DELETE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS",
  ACTION_DELETE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL: "ACTION_DELETE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL",

  // TKT1 Trusted Bank Visa Actions
  ACTION_GET_TKT1_TRUSTED_BANK_VISAS_SUCCESS: "ACTION_GET_TKT1_TRUSTED_BANK_VISAS_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_BANK_VISAS_FAIL: "ACTION_GET_TKT1_TRUSTED_BANK_VISAS_FAIL",
  ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_ID_SUCCESS: "ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_ID_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_ID_FAIL: "ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_ID_FAIL",
  ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_VISA_NUMBER_SUCCESS: "ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_VISA_NUMBER_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_VISA_NUMBER_FAIL: "ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_VISA_NUMBER_FAIL",
  ACTION_SEARCH_TKT1_TRUSTED_BANK_VISAS_SUCCESS: "ACTION_SEARCH_TKT1_TRUSTED_BANK_VISAS_SUCCESS",
  ACTION_SEARCH_TKT1_TRUSTED_BANK_VISAS_FAIL: "ACTION_SEARCH_TKT1_TRUSTED_BANK_VISAS_FAIL",
  ACTION_CREATE_TKT1_TRUSTED_BANK_VISA_SUCCESS: "ACTION_CREATE_TKT1_TRUSTED_BANK_VISA_SUCCESS",
  ACTION_CREATE_TKT1_TRUSTED_BANK_VISA_FAIL: "ACTION_CREATE_TKT1_TRUSTED_BANK_VISA_FAIL",
  ACTION_UPDATE_TKT1_TRUSTED_BANK_VISA_SUCCESS: "ACTION_UPDATE_TKT1_TRUSTED_BANK_VISA_SUCCESS",
  ACTION_UPDATE_TKT1_TRUSTED_BANK_VISA_FAIL: "ACTION_UPDATE_TKT1_TRUSTED_BANK_VISA_FAIL",
  ACTION_DELETE_TKT1_TRUSTED_BANK_VISA_SUCCESS: "ACTION_DELETE_TKT1_TRUSTED_BANK_VISA_SUCCESS",
  ACTION_DELETE_TKT1_TRUSTED_BANK_VISA_FAIL: "ACTION_DELETE_TKT1_TRUSTED_BANK_VISA_FAIL",

  // TKT1 Scan Person Actions
  ACTION_GET_TKT1_SCAN_PERSONS_SUCCESS: "ACTION_GET_TKT1_SCAN_PERSONS_SUCCESS",
  ACTION_GET_TKT1_SCAN_PERSONS_FAIL: "ACTION_GET_TKT1_SCAN_PERSONS_FAIL",
  ACTION_GET_TKT1_SCAN_PERSON_BY_ID_SUCCESS: "ACTION_GET_TKT1_SCAN_PERSON_BY_ID_SUCCESS",
  ACTION_GET_TKT1_SCAN_PERSON_BY_ID_FAIL: "ACTION_GET_TKT1_SCAN_PERSON_BY_ID_FAIL",
  ACTION_GET_TKT1_SCAN_PERSON_BY_MID_SUCCESS: "ACTION_GET_TKT1_SCAN_PERSON_BY_MID_SUCCESS",
  ACTION_GET_TKT1_SCAN_PERSON_BY_MID_FAIL: "ACTION_GET_TKT1_SCAN_PERSON_BY_MID_FAIL",
  ACTION_SEARCH_TKT1_SCAN_PERSONS_SUCCESS: "ACTION_SEARCH_TKT1_SCAN_PERSONS_SUCCESS",
  ACTION_SEARCH_TKT1_SCAN_PERSONS_FAIL: "ACTION_SEARCH_TKT1_SCAN_PERSONS_FAIL",
  ACTION_CREATE_TKT1_SCAN_PERSON_SUCCESS: "ACTION_CREATE_TKT1_SCAN_PERSON_SUCCESS",
  ACTION_CREATE_TKT1_SCAN_PERSON_FAIL: "ACTION_CREATE_TKT1_SCAN_PERSON_FAIL",
  ACTION_UPDATE_TKT1_SCAN_PERSON_SUCCESS: "ACTION_UPDATE_TKT1_SCAN_PERSON_SUCCESS",
  ACTION_UPDATE_TKT1_SCAN_PERSON_FAIL: "ACTION_UPDATE_TKT1_SCAN_PERSON_FAIL",
  ACTION_DELETE_TKT1_SCAN_PERSON_SUCCESS: "ACTION_DELETE_TKT1_SCAN_PERSON_SUCCESS",
  ACTION_DELETE_TKT1_SCAN_PERSON_FAIL: "ACTION_DELETE_TKT1_SCAN_PERSON_FAIL",

  // TKT1 Trusted Story Actions
  ACTION_GET_TKT1_TRUSTED_STORIES_SUCCESS: "ACTION_GET_TKT1_TRUSTED_STORIES_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_STORIES_FAIL: "ACTION_GET_TKT1_TRUSTED_STORIES_FAIL",
  ACTION_GET_TKT1_TRUSTED_STORY_BY_ID_SUCCESS: "ACTION_GET_TKT1_TRUSTED_STORY_BY_ID_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_STORY_BY_ID_FAIL: "ACTION_GET_TKT1_TRUSTED_STORY_BY_ID_FAIL",
  ACTION_GET_TKT1_TRUSTED_STORY_BY_MID_SUCCESS: "ACTION_GET_TKT1_TRUSTED_STORY_BY_MID_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_STORY_BY_MID_FAIL: "ACTION_GET_TKT1_TRUSTED_STORY_BY_MID_FAIL",
  ACTION_GET_TKT1_TRUSTED_STORY_TEMPLATES_SUCCESS: "ACTION_GET_TKT1_TRUSTED_STORY_TEMPLATES_SUCCESS",
  ACTION_GET_TKT1_TRUSTED_STORY_TEMPLATES_FAIL: "ACTION_GET_TKT1_TRUSTED_STORY_TEMPLATES_FAIL",
  ACTION_SEARCH_TKT1_TRUSTED_STORIES_SUCCESS: "ACTION_SEARCH_TKT1_TRUSTED_STORIES_SUCCESS",
  ACTION_SEARCH_TKT1_TRUSTED_STORIES_FAIL: "ACTION_SEARCH_TKT1_TRUSTED_STORIES_FAIL",
  ACTION_CREATE_TKT1_TRUSTED_STORY_SUCCESS: "ACTION_CREATE_TKT1_TRUSTED_STORY_SUCCESS",
  ACTION_CREATE_TKT1_TRUSTED_STORY_FAIL: "ACTION_CREATE_TKT1_TRUSTED_STORY_FAIL",
  ACTION_UPDATE_TKT1_TRUSTED_STORY_SUCCESS: "ACTION_UPDATE_TKT1_TRUSTED_STORY_SUCCESS",
  ACTION_UPDATE_TKT1_TRUSTED_STORY_FAIL: "ACTION_UPDATE_TKT1_TRUSTED_STORY_FAIL",
  ACTION_DELETE_TKT1_TRUSTED_STORY_SUCCESS: "ACTION_DELETE_TKT1_TRUSTED_STORY_SUCCESS",
  ACTION_DELETE_TKT1_TRUSTED_STORY_FAIL: "ACTION_DELETE_TKT1_TRUSTED_STORY_FAIL",

  // TKT1 Etsy Info Pack Actions
  ACTION_GET_TKT1_ETSY_INFO_PACKS_SUCCESS: "ACTION_GET_TKT1_ETSY_INFO_PACKS_SUCCESS",
  ACTION_GET_TKT1_ETSY_INFO_PACKS_FAIL: "ACTION_GET_TKT1_ETSY_INFO_PACKS_FAIL",
  ACTION_GET_TKT1_ETSY_INFO_PACK_BY_ID_SUCCESS: "ACTION_GET_TKT1_ETSY_INFO_PACK_BY_ID_SUCCESS",
  ACTION_GET_TKT1_ETSY_INFO_PACK_BY_ID_FAIL: "ACTION_GET_TKT1_ETSY_INFO_PACK_BY_ID_FAIL",
  ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_SUCCESS: "ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_SUCCESS",
  ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_FAIL: "ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_FAIL",
  ACTION_SEARCH_TKT1_ETSY_INFO_PACKS_SUCCESS: "ACTION_SEARCH_TKT1_ETSY_INFO_PACKS_SUCCESS",
  ACTION_SEARCH_TKT1_ETSY_INFO_PACKS_FAIL: "ACTION_SEARCH_TKT1_ETSY_INFO_PACKS_FAIL",
  ACTION_CREATE_TKT1_ETSY_INFO_PACK_SUCCESS: "ACTION_CREATE_TKT1_ETSY_INFO_PACK_SUCCESS",
  ACTION_CREATE_TKT1_ETSY_INFO_PACK_FAIL: "ACTION_CREATE_TKT1_ETSY_INFO_PACK_FAIL",
  ACTION_UPDATE_TKT1_ETSY_INFO_PACK_SUCCESS: "ACTION_UPDATE_TKT1_ETSY_INFO_PACK_SUCCESS",
  ACTION_UPDATE_TKT1_ETSY_INFO_PACK_FAIL: "ACTION_UPDATE_TKT1_ETSY_INFO_PACK_FAIL",
  ACTION_DELETE_TKT1_ETSY_INFO_PACK_SUCCESS: "ACTION_DELETE_TKT1_ETSY_INFO_PACK_SUCCESS",
  ACTION_DELETE_TKT1_ETSY_INFO_PACK_FAIL: "ACTION_DELETE_TKT1_ETSY_INFO_PACK_FAIL",

  // TKT1 File Upload Management Actions
  ACTION_GET_TKT1_FILE_UPLOADS_SUCCESS: "ACTION_GET_TKT1_FILE_UPLOADS_SUCCESS",
  ACTION_GET_TKT1_FILE_UPLOADS_FAIL: "ACTION_GET_TKT1_FILE_UPLOADS_FAIL",
  ACTION_GET_TKT1_FILE_UPLOAD_STATS_SUCCESS: "ACTION_GET_TKT1_FILE_UPLOAD_STATS_SUCCESS",
  ACTION_GET_TKT1_FILE_UPLOAD_STATS_FAIL: "ACTION_GET_TKT1_FILE_UPLOAD_STATS_FAIL",
  ACTION_SEARCH_TKT1_FILE_UPLOADS_SUCCESS: "ACTION_SEARCH_TKT1_FILE_UPLOADS_SUCCESS",
  ACTION_SEARCH_TKT1_FILE_UPLOADS_FAIL: "ACTION_SEARCH_TKT1_FILE_UPLOADS_FAIL",
  ACTION_GET_TKT1_FILE_UPLOAD_BY_ID_SUCCESS: "ACTION_GET_TKT1_FILE_UPLOAD_BY_ID_SUCCESS",
  ACTION_GET_TKT1_FILE_UPLOAD_BY_ID_FAIL: "ACTION_GET_TKT1_FILE_UPLOAD_BY_ID_FAIL",
  ACTION_CREATE_TKT1_FILE_UPLOAD_SUCCESS: "ACTION_CREATE_TKT1_FILE_UPLOAD_SUCCESS",
  ACTION_CREATE_TKT1_FILE_UPLOAD_FAIL: "ACTION_CREATE_TKT1_FILE_UPLOAD_FAIL",
  ACTION_UPDATE_TKT1_FILE_UPLOAD_SUCCESS: "ACTION_UPDATE_TKT1_FILE_UPLOAD_SUCCESS",
  ACTION_UPDATE_TKT1_FILE_UPLOAD_FAIL: "ACTION_UPDATE_TKT1_FILE_UPLOAD_FAIL",
  ACTION_DELETE_TKT1_FILE_UPLOAD_SUCCESS: "ACTION_DELETE_TKT1_FILE_UPLOAD_SUCCESS",
  ACTION_DELETE_TKT1_FILE_UPLOAD_FAIL: "ACTION_DELETE_TKT1_FILE_UPLOAD_FAIL",

  // TKT1 Image Album Actions
  ACTION_GET_TKT1_IMAGE_ALBUMS_SUCCESS: "ACTION_GET_TKT1_IMAGE_ALBUMS_SUCCESS",
  ACTION_GET_TKT1_IMAGE_ALBUMS_FAIL: "ACTION_GET_TKT1_IMAGE_ALBUMS_FAIL",
  ACTION_GET_TKT1_IMAGE_ALBUM_BY_ID_SUCCESS: "ACTION_GET_TKT1_IMAGE_ALBUM_BY_ID_SUCCESS",
  ACTION_GET_TKT1_IMAGE_ALBUM_BY_ID_FAIL: "ACTION_GET_TKT1_IMAGE_ALBUM_BY_ID_FAIL",
  ACTION_GET_TKT1_IMAGE_ALBUM_BY_MID_SUCCESS: "ACTION_GET_TKT1_IMAGE_ALBUM_BY_MID_SUCCESS",
  ACTION_GET_TKT1_IMAGE_ALBUM_BY_MID_FAIL: "ACTION_GET_TKT1_IMAGE_ALBUM_BY_MID_FAIL",
  ACTION_CREATE_TKT1_IMAGE_ALBUM_SUCCESS: "ACTION_CREATE_TKT1_IMAGE_ALBUM_SUCCESS",
  ACTION_CREATE_TKT1_IMAGE_ALBUM_FAIL: "ACTION_CREATE_TKT1_IMAGE_ALBUM_FAIL",
  ACTION_UPDATE_TKT1_IMAGE_ALBUM_SUCCESS: "ACTION_UPDATE_TKT1_IMAGE_ALBUM_SUCCESS",
  ACTION_UPDATE_TKT1_IMAGE_ALBUM_FAIL: "ACTION_UPDATE_TKT1_IMAGE_ALBUM_FAIL",
  ACTION_DELETE_TKT1_IMAGE_ALBUM_SUCCESS: "ACTION_DELETE_TKT1_IMAGE_ALBUM_SUCCESS",
  ACTION_DELETE_TKT1_IMAGE_ALBUM_FAIL: "ACTION_DELETE_TKT1_IMAGE_ALBUM_FAIL",

  // TKT1 Registered Etsy Shop Actions
  ACTION_GET_TKT1_REGISTERED_ETSY_SHOPS_SUCCESS: "ACTION_GET_TKT1_REGISTERED_ETSY_SHOPS_SUCCESS",
  ACTION_GET_TKT1_REGISTERED_ETSY_SHOPS_FAIL: "ACTION_GET_TKT1_REGISTERED_ETSY_SHOPS_FAIL",
  ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_ID_SUCCESS: "ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_ID_SUCCESS",
  ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_ID_FAIL: "ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_ID_FAIL",
  ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_MID_SUCCESS: "ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_MID_SUCCESS",
  ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_MID_FAIL: "ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_MID_FAIL",
  ACTION_SEARCH_TKT1_REGISTERED_ETSY_SHOPS_SUCCESS: "ACTION_SEARCH_TKT1_REGISTERED_ETSY_SHOPS_SUCCESS",
  ACTION_SEARCH_TKT1_REGISTERED_ETSY_SHOPS_FAIL: "ACTION_SEARCH_TKT1_REGISTERED_ETSY_SHOPS_FAIL",
  ACTION_CREATE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS: "ACTION_CREATE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS",
  ACTION_CREATE_TKT1_REGISTERED_ETSY_SHOP_FAIL: "ACTION_CREATE_TKT1_REGISTERED_ETSY_SHOP_FAIL",
  ACTION_UPDATE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS: "ACTION_UPDATE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS",
  ACTION_UPDATE_TKT1_REGISTERED_ETSY_SHOP_FAIL: "ACTION_UPDATE_TKT1_REGISTERED_ETSY_SHOP_FAIL",
  ACTION_DELETE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS: "ACTION_DELETE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS",
  ACTION_DELETE_TKT1_REGISTERED_ETSY_SHOP_FAIL: "ACTION_DELETE_TKT1_REGISTERED_ETSY_SHOP_FAIL",

  // TKT1 Product Actions
  ACTION_GET_TKT1_PRODUCTS_SUCCESS: "ACTION_GET_TKT1_PRODUCTS_SUCCESS",
  ACTION_GET_TKT1_PRODUCTS_FAIL: "ACTION_GET_TKT1_PRODUCTS_FAIL",
  ACTION_GET_TKT1_PRODUCT_BY_ID_SUCCESS: "ACTION_GET_TKT1_PRODUCT_BY_ID_SUCCESS",
  ACTION_GET_TKT1_PRODUCT_BY_ID_FAIL: "ACTION_GET_TKT1_PRODUCT_BY_ID_FAIL",
  ACTION_GET_TKT1_PRODUCT_BY_MID_SUCCESS: "ACTION_GET_TKT1_PRODUCT_BY_MID_SUCCESS",
  ACTION_GET_TKT1_PRODUCT_BY_MID_FAIL: "ACTION_GET_TKT1_PRODUCT_BY_MID_FAIL",
  ACTION_CREATE_TKT1_PRODUCT_SUCCESS: "ACTION_CREATE_TKT1_PRODUCT_SUCCESS",
  ACTION_CREATE_TKT1_PRODUCT_FAIL: "ACTION_CREATE_TKT1_PRODUCT_FAIL",
  ACTION_UPDATE_TKT1_PRODUCT_SUCCESS: "ACTION_UPDATE_TKT1_PRODUCT_SUCCESS",
  ACTION_UPDATE_TKT1_PRODUCT_FAIL: "ACTION_UPDATE_TKT1_PRODUCT_FAIL",
  ACTION_UPDATE_TKT1_PRODUCT_BY_MID_SUCCESS: "ACTION_UPDATE_TKT1_PRODUCT_BY_MID_SUCCESS",
  ACTION_UPDATE_TKT1_PRODUCT_BY_MID_FAIL: "ACTION_UPDATE_TKT1_PRODUCT_BY_MID_FAIL",
  ACTION_DELETE_TKT1_PRODUCT_SUCCESS: "ACTION_DELETE_TKT1_PRODUCT_SUCCESS",
  ACTION_DELETE_TKT1_PRODUCT_FAIL: "ACTION_DELETE_TKT1_PRODUCT_FAIL",
  ACTION_SEARCH_TKT1_PRODUCTS_SUCCESS: "ACTION_SEARCH_TKT1_PRODUCTS_SUCCESS",
  ACTION_SEARCH_TKT1_PRODUCTS_FAIL: "ACTION_SEARCH_TKT1_PRODUCTS_FAIL",

  // TKT1 ONM Design Actions
  ACTION_GET_TKT1_ONM_DESIGNS_SUCCESS: "ACTION_GET_TKT1_ONM_DESIGNS_SUCCESS",
  ACTION_GET_TKT1_ONM_DESIGNS_FAIL: "ACTION_GET_TKT1_ONM_DESIGNS_FAIL",
  ACTION_GET_TKT1_ONM_DESIGN_BY_ID_SUCCESS: "ACTION_GET_TKT1_ONM_DESIGN_BY_ID_SUCCESS",
  ACTION_GET_TKT1_ONM_DESIGN_BY_ID_FAIL: "ACTION_GET_TKT1_ONM_DESIGN_BY_ID_FAIL",
  ACTION_CREATE_TKT1_ONM_DESIGN_SUCCESS: "ACTION_CREATE_TKT1_ONM_DESIGN_SUCCESS",
  ACTION_CREATE_TKT1_ONM_DESIGN_FAIL: "ACTION_CREATE_TKT1_ONM_DESIGN_FAIL",
  ACTION_UPDATE_TKT1_ONM_DESIGN_SUCCESS: "ACTION_UPDATE_TKT1_ONM_DESIGN_SUCCESS",
  ACTION_UPDATE_TKT1_ONM_DESIGN_FAIL: "ACTION_UPDATE_TKT1_ONM_DESIGN_FAIL",
  ACTION_DELETE_TKT1_ONM_DESIGN_SUCCESS: "ACTION_DELETE_TKT1_ONM_DESIGN_SUCCESS",
  ACTION_DELETE_TKT1_ONM_DESIGN_FAIL: "ACTION_DELETE_TKT1_ONM_DESIGN_FAIL"
}

export default TYPES;
